import React, {useState, useEffect} from 'react';
import {Read} from '../../components/Shared/Api'
import {Ts} from '../../config/switcher';

import {meSplitter} from '../../components/Shared/meLayout'

const Planner = ({account, search}) => {
  const app = 'Planner'
  const container = 'HomeContainer'

  const [layouts, Layouts]= useState([])
  
  const splitter = new meSplitter("Side", container)
  
  useEffect(()=>{
    if(account.connected) {
      Read(`/Layout/${container}`,Layouts,null,null)
    }
  },[])

  useEffect(()=>{
    splitter.InitStyle(layouts)
  },[layouts])


  return (
  account.connected ?
    <div className="Sides" id="HomeContainer" 
        onMouseDown={(e)=>{splitter.mouseDown(e)}} 
        onMouseMove={(e)=>{splitter.mouseMove(e)}} 
        onMouseUp={(e)=>{splitter.mouseUp(e)}}
        >
        <div className="side vside" id="SideSection" style={{width: '20%', height:'100%'}}>
            <div className="Title">Projects</div>
        </div>
        <div className="side vside" id="SideNote" style={{width: '50%', height:'100%'}}>
          <div className="Title">Details</div>
        </div>
        <div className="side vside" id="SideDetail" style={{width: '30%', height:'100%'}}>
          <div className="Title">Resources</div>
        </div>
    </div>
  : 
    <div className="Sides">LogIn</div> 
)
    
}

export {Planner}